import { Profile } from 'common/types/api';
import { authorizedFetch } from 'common/utils/http';
import { RequestOptions } from 'https';

class UserProfile {
  async fetchProfile(options?: RequestOptions): Promise<Profile> {
    const { res } = await authorizedFetch<Profile, void>(
      {
        url: 'profile',
        method: 'GET',
      },
      options,
    );

    return res;
  }

  async updateProfile(data: Partial<Profile>): Promise<void> {
    await authorizedFetch<void, Partial<Profile>>({
      url: 'profile',
      method: 'PUT',
      payload: data,
    });
  }

  async removeProfile(): Promise<void> {
    await authorizedFetch<void, void>({
      url: 'profile',
      method: 'DELETE',
    });
  }
}

export const userProfile = new UserProfile();
